// import axios from 'axios';
export default {
  data() {
    return {
      trackerData: {
        trackerLocation: null,
        trackerId: 1,
        trackerToken: "b4497e36ab3bca3283b6aa8eb994adce",
        trackerUserId: null
      }
    };
  },
  methods: {
    initTracker() {
      this.trackerData.trackerLocation = window.location.hostname;
      this.trackerData.trackerUserId = this.$store.state.user.userId;
      if (
        this.trackerData.trackerLocation != "painel.ulisite.com" &&
        this.trackerData.trackerLocation != "localhost"
      ) {
        this.trackerData.trackerId = 2;
        this.trackerData.trackerToken = "bb8f476c9a96d3df4a6212a0b5bfe901";
      }
    },
    trackerSubmit() {
      var trackerAux = window.localStorage.getItem("tracker");

      if (trackerAux) {
        trackerAux = JSON.parse(trackerAux);
        let api = "https://proxy.ulisite.com/api/tracker";
        let item = null;
        let data = null;
        //Faz o submit dos itens e limpa o array
        for (var i in trackerAux) {
          item = trackerAux[i];

          data = new FormData();
          data.set("app", item.app);
          data.set("user", item.user);
          data.set('id', item.id);
          data.set("register_id", item.register_id);
          data.set("tag", item.tag);
          data.set("token", item.token);

          let request = new XMLHttpRequest();

          request.open("POST", api, true);
          request.send(data);
        }
      }
      window.localStorage.removeItem("tracker");
    },
    registerTracker(register_id, tag) {
      //Pego o id da sessão do painel e gravo na variável que vou mandar pro tracker
      var session = this.$session.get('sessionId');
      //verifico se tem sessão vinda da landing no localStorage
      if(window.localStorage.getItem('landing_session')){
        //Se tiver, seto ela na sessão que vou mandar pro tracker
        session = window.localStorage.getItem('landing_session');
      }

      var data = {
        app: this.trackerData.trackerId,
        user: this.trackerData.trackerUserId,
        id: session,
        register_id: register_id,
        tag: tag,
        token: this.trackerData.trackerToken
      };

      //Puxa o tracker do localstorage e transforma em objeto
      var trackerAux = localStorage.getItem("tracker");

      //Se não tiver, cria um novo Array com o objeto
      if (!trackerAux) {
        trackerAux = [];
      } else {
        trackerAux = JSON.parse(trackerAux);
      }

      //Insere o objeto no array
      trackerAux.push(data);

      //transforma o tracker em string e salva o array no localstorage
      window.localStorage.setItem("tracker", JSON.stringify(trackerAux));

      return trackerAux;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/trackerScripts.js